export const logLevels = ['debug', 'info', 'warn', 'error', 'none'];

let envLogLevel = process.env.REACT_APP_LOG_LEVEL;
console.log('utils/LogLevels: envLogLevel = ', envLogLevel);
console.log('utils/LogLevels: typeof envLogLevel = ', typeof envLogLevel);
//if (typeof envLogLevel == 'string') envLogLevel = parseInt(typeof envLogLevel);
//console.log('utils/LogLevels: typeof envLogLevel = ', typeof envLogLevel);

//let logLevel = 'debug';
//let logLevel = 'info';
//let logLevel = 'warn';
let logLevel = logLevels[envLogLevel];
console.log('utils/LogLevels: logLevel = ', logLevel);

const shouldLog = (level) => {
    return logLevels.indexOf(level) >= logLevels.indexOf(logLevel);
};

const windowConsole = window.console;

window.console = {
    ...window.console
    , log: (message?, ...optionalParams) => {
        shouldLog('debug') && windowConsole.log(message, ...optionalParams);
    }
    , info: (message?, ...optionalParams) => {
        shouldLog('info') && windowConsole.warn(message, ...optionalParams);
    }
    , warn: (message?, ...optionalParams) => {
        shouldLog('warn') && windowConsole.warn(message, ...optionalParams);
    }
    , error: (message?, ...optionalParams) => {
        shouldLog('error') && windowConsole.error(message, ...optionalParams);
    }
    , debug: (message?, ...optionalParams) => {
        shouldLog('debug') && windowConsole.debug(message, ...optionalParams);
    }
};